var map = {
	"../tab1/tab1.module": [
		"./src/app/tab1/tab1.module.ts",
		"tab1-tab1-module"
	],
	"../tab2/tab2.module": [
		"./src/app/tab2/tab2.module.ts",
		"tab2-tab2-module"
	],
	"../tab3/tab3.module": [
		"./src/app/tab3/tab3.module.ts",
		"tab3-tab3-module"
	],
	"./autenticacion/inicio-sesion/inicio-sesion.module": [
		"./src/app/autenticacion/inicio-sesion/inicio-sesion.module.ts",
		"autenticacion-inicio-sesion-inicio-sesion-module"
	],
	"./autenticacion/registro/registro.module": [
		"./src/app/autenticacion/registro/registro.module.ts",
		"autenticacion-registro-registro-module"
	],
	"./ayuda/ayuda.module": [
		"./src/app/ayuda/ayuda.module.ts",
		"ayuda-ayuda-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"tabs-tabs-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;